export default function (target) {
    return new Promise((resolve, reject) => {
            const modal = $(target);
            if (modal.length) {
                modal.find('.btn-action').click((e) => {
                    resolve($(e.target).data('action'));
                })
                modal.find('.btn-ok').click(() => resolve(true))
                modal.find('.btn-close').click(() => resolve(false))
                modal.modal('show');
            } else {
                setTimeout(() => reject('Modal not found'), 0);
            }
        }
    )
}
